module.exports = __webpack_public_path__ + "static/media/user-skill.91275c49.svg";